import { Link } from 'react-router-dom'

import { Asset, Call, Equipment } from '@/services/backend/config/entities'

import { Chamados } from '..'

type Extended = Call & {
  Asset: Asset & { Equipment?: Equipment }
}

interface Props {
  redirectTo: string
  data: Extended
}

export default function Component({ data, redirectTo }: Props) {
  return (
    <Link to={redirectTo}>
      <div className="rounded-lg border p-4 bg-background hover:bg-muted">
        <div className="flex items-center justify-between gap-2">
          <p className="font-bold">{data.id}</p>
          <Chamados.Core.StatusBadge status={data.status} />
        </div>
        <p className="text-sm">{data.description}</p>
        <p className="text-xs">{new Date(data.createdAt).toLocaleString()}</p>
        <Chamados.Core.TempoAtendimento_ProgressBar
          status={data.status}
          createdAt={data.createdAt}
        />
      </div>
    </Link>
  )
}
